import type { SVGProps } from 'react';

export function EarthIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 21.6a9.6 9.6 0 0 0 9.6-9.6A9.6 9.6 0 0 0 12 2.4 9.6 9.6 0 0 0 2.4 12a9.6 9.6 0 0 0 9.6 9.6M9.6 8.047c0-.468.379-.847.848-.847H12c.664 0 1.2.536 1.2 1.2s-.536 1.2-1.2 1.2h-.701c-.319 0-.623-.128-.848-.353l-.6-.6a.85.85 0 0 1-.247-.6zm9 3.953c.33 0 .6.27.6.6v1.2c0 .33-.27.6-.6.6s-.6-.27-.6-.6v-1.2c0-.33.27-.6.6-.6m-.776 4.624-1.2 1.2a.6.6 0 0 1-.848 0 .6.6 0 0 1 0-.848l1.2-1.2a.6.6 0 0 1 .848 0 .6.6 0 0 1 0 .848M10.8 18.6c0-.33.27-.6.6-.6h1.2c.33 0 .6.27.6.6s-.27.6-.6.6h-1.2c-.33 0-.6-.27-.6-.6m-3.6-3c-.664 0-1.2-.536-1.2-1.2v-.701c0-.32.127-.623.352-.848l1.8-1.8a.85.85 0 0 1 .6-.247H9c.33 0 .6.27.6.6s.27.6.6.6.6-.27.6-.6.27-.6.6-.6h.248c.225 0 .442.09.6.247l1.8 1.8c.225.225.352.529.352.848v1.9c0 .665-.536 1.2-1.2 1.2h-1.901c-.319 0-.623-.127-.848-.352l-.499-.498a1.2 1.2 0 0 0-.847-.353z" />
    </svg>
  );
}
